import { render } from "./WebPage.vue?vue&type=template&id=35fc409a&scoped=true"
import script from "./WebPage.vue?vue&type=script&lang=js"
export * from "./WebPage.vue?vue&type=script&lang=js"

import "./WebPage.vue?vue&type=style&index=0&id=35fc409a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fc409a"]])

export default __exports__